import { useApolloClient } from '@apollo/client';
import { Button, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Page } from './Page';
import { PageContent } from './PageContent';

interface Props {
  resetError: () => void;
}

export function AppError({ resetError }: Props) {
  const apollo = useApolloClient();

  useEffect(() => {
    apollo.clearStore();
  }, [apollo]);

  return (
    <Page title="Oops…" pageName="error" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          It appears something is not working as expected.
        </Text>
        <Text marginTop="8" fontSize="sm">
          <Button variant="link" size="sm" colorScheme="blue" onClick={() => resetError()}>
            Try again
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
